package com.arena_web.utils

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue

/**
 * Cross-cutting client settings backed by localStorage but reactive to
 * Compose readers — writes flow through here so any composable observing
 * the state recomposes immediately.
 */
object AppSettings {
    var globalPalette by mutableStateOf(
        Storage.get(StorageKeys.GLOBAL_PALETTE)?.lowercase(),
    )
        private set

    fun setGlobalPalette(value: String?) {
        val normalized = value?.lowercase()
        if (normalized == null) {
            Storage.remove(StorageKeys.GLOBAL_PALETTE)
        } else {
            Storage.save(StorageKeys.GLOBAL_PALETTE, normalized)
        }
        globalPalette = normalized
    }
}
